var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PageSpace m-hp-100 m-fb-col m-hidden m-fb-cross-center"},[_c('div',{staticClass:"m-hp-100 m-fb m-hidden m-wp-100"},[_c('iframe',{staticClass:"m-hp-100 m-wp-100",attrs:{"name":"mainIframe","src":"https://booking.lib.zju.edu.cn","frameborder":"0","scrolling":"auto"}})])])
}]

export { render, staticRenderFns }